<template>
  <DxForm id="formularioOfertaEnergia" ref="formInstance" :form-data="model" label-location="top"
  :show-colon-after-label="false" :visible="model != null" validation-group="validacionOfertaEnergia">
  <!-- xs: 768, sm: 992, md:1200 -->
    <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

    <!-- Datos de la oferta -->
    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem data-field="EmpresaServicios" editor-type="dxTextBox" :col-span="2" :editor-options="{ readOnly: true }">
        <DxLabel :text="$t('oferta_energia.form.nombre_empresa_servicios')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="IdEsave" editor-type="dxNumberBox" :col-span="2" :editor-options="{ readOnly: true }">
        <DxLabel :text="$t('oferta_energia.form.idEsave')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Activa" :col-span="2" css-class="activa-checkbox">
        <DxCheckBox v-model="props.model!.Activa" :text="$t('oferta_energia.form.activa')" />
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="3">
        <DxLabel :text="$t('oferta_energia.form.nombre')" />
        <DxRequiredRule :message="$t('oferta_energia.form.validacion.nombre')" :reevaluate="true" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="3">
      </DxEmptyItem>
      <DxSimpleItem data-field="CodigoTalonario" editor-type="dxTextBox" :col-span="3">
        <DxLabel template="codigoTalonarioLabel" />
        <DxRequiredRule v-if="requiereCodigoTalonario" :message="$t('oferta_energia.form_endesa.validacion.codigo_talonario')" :reevaluate="true" />
      </DxSimpleItem>
      <DxSimpleItem :visible="tieneDenominacionInterna" data-field="DenominacionInterna" editor-type="dxTextBox" :col-span="3">
        <DxLabel template="denoInternaLabel" />
        <DxRequiredRule :message="$t('oferta_energia.form.validacion.deno_interna')" :reevaluate="true" />
      </DxSimpleItem>
      <DxSimpleItem :visible="tieneMiscelanea" data-field="DatosEndesa.Miscelanea" editor-type="dxTextBox" :col-span="3">
        <DxLabel template="miscelaneaLabel" />
        <DxRequiredRule :message="$t('oferta_energia.form_endesa.validacion.miscelanea')" :reevaluate="true" />
      </DxSimpleItem>
      <DxEmptyItem :visible="(tieneMiscelanea && !tieneDenominacionInterna || !tieneMiscelanea && !tieneDenominacionInterna)" :col-span="3"></DxEmptyItem>
      <DxSimpleItem data-field="FechaInicio" editor-type="dxDateBox" :col-span="2"
        :editor-options="{ readOnly: tieneTramitesAsociados }">
        <DxLabel :text="$t('oferta_energia.form.fecha_inicio')" />
        <DxRequiredRule :message="$t('oferta_energia.form.validacion.fecha_inicio')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="FechaFin" editor-type="dxDateBox" :col-span="2" :is-required="true">
        <DxDateBox v-model="props.model!.FechaFin" validation-message-mode="always">
          <DxValidator ref="validatorFechaFin" validation-group="validacionFechaFin">
            <DxRequiredRule :message="$t('oferta_energia.form.validacion.fecha_fin')" />
            <DxCompareRule :comparison-target="fechaInicio" :comparison-type="'>'"
              :message="$t('oferta_energia.form.validacion.fecha_fin_mayor')" :reevaluate="true" />
          </DxValidator>
        </DxDateBox>
        <DxLabel :text="$t('oferta_energia.form.fecha_fin')" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="2">
      </DxEmptyItem>
      <DxSimpleItem data-field="TipoEnergia" editor-type="dxSelectBox" :col-span="2" :editor-options="selectTipoEnergia">
        <DxLabel :text="$t('oferta_energia.form.tipo_energia')" />
        <DxRequiredRule :message="$t('oferta_energia.form.validacion.tipo_energia')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="TarifaAcceso" editor-type="dxSelectBox" :col-span="2" :editor-options="selectTarifaAcceso">
        <DxLabel :text="$t('oferta_energia.form.tarifa_acceso')" />
        <DxRequiredRule :message="$t('oferta_energia.form.validacion.tarifa_acceso')" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="2">
      </DxEmptyItem>
    </DxGroupItem>
    
    <!-- Checks de tipo de persona -->
    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem data-field="AplicaPersonaFisica" :col-span="2">
        <DxCheckBox v-model="props.model!.AplicaPersonaFisica" :read-only="tieneTramitesAsociados"
          :text="$t('oferta_energia.form.aplica_persona_fisica')" validation-message-mode="always"
          validation-message-position="right">
          <DxValidator ref="validatorTipoPersona" validation-group="validacionTipoPersona">
            <DxCustomRule :validation-callback="validarTipoPersona" message="" :reevaluate="true" />
          </DxValidator>
        </DxCheckBox>
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem data-field="AplicaPersonaJuridica" :col-span="2">
        <DxCheckBox v-model="props.model!.AplicaPersonaJuridica" :read-only="tieneTramitesAsociados"
          :text="$t('oferta_energia.form.aplica_persona_juridica')" validation-message-mode="always"
          validation-message-position="right">
          <DxValidator ref="validatorTipoPersona" validation-group="validacionTipoPersona">
            <DxCustomRule :validation-callback="validarTipoPersona"
              :message="$t('oferta_energia.form.validacion.tipo_persona')" :reevaluate="true" />
          </DxValidator>
        </DxCheckBox>
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxEmptyItem :visible="hayDatosLuz" :col-span="2">
      </DxEmptyItem>
    </DxGroupItem>

    <!-- Seccion de datos asociados a ofertas de luz -->
    <DxGroupItem :col-span="6" :col-count="6" :css-class="claseDatosLuz">
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.Autoconsumo" :col-span="6">
        <DxCheckBox v-model="autoconsumoValue" :read-only="tieneTramitesAsociados"
          :text="$t('oferta_energia.form.autoconsumo')" />
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.PotenciaMin" editor-type="dxNumberBox" :col-span="2"
        :editor-options="potenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.potencia_minima')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.PotenciaMax" editor-type="dxNumberBox" :col-span="2">
        <DxNumberBox v-model="potenciaMaxValue" :read-only="tieneTramitesAsociados"
        validation-message-mode="always" validation-message-position="right" v-bind="potenciaNumberOptions">
          <DxValidator ref="validatorPotenciaMax" validation-group="validacionPotenciaMax">
            <DxCompareRule :comparison-target="potenciaMin" :comparison-type="'>='"
              :message="$t('oferta_energia.form.validacion.potencia_maxima')" :reevaluate="true" />
          </DxValidator>
        </DxNumberBox>
        <DxLabel :text="$t('oferta_energia.form.potencia_maxima')" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="2">
      </DxEmptyItem>
    </DxGroupItem>

    <!-- Seccion de datos exclusivos de luz -->
    <DxGroupItem :col-span="6" :col-count="6" :css-class="claseDatosLuz">
      <DxSimpleItem :visible="hayDatosLuz" :col-span="6">
        <span class="dx-field-item-label-text text-success">{{
          $t('oferta_energia.form.termino_potencia')
        }}</span>
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.TerminoPotencia.P1" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p1')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.TerminoPotencia.P2" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p2')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoPotencia.P3"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p3')" />
      </DxSimpleItem>
      <DxEmptyItem :visible="hayDatosLuz && !esTarifaHastaP6" :col-span="2">
      </DxEmptyItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoPotencia.P4"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p4')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoPotencia.P5"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p5')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoPotencia.P6"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioPotenciaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p6')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" :col-span="6">
        <span class="dx-field-item-label-text text-success">{{
          $t('oferta_energia.form.termino_energia')
        }}</span>
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.TerminoEnergia.P1" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p1')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.TerminoEnergia.P2" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p2')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz" data-field="DatosLuz.TerminoEnergia.P3" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p3')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoEnergia.P4"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p4')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoEnergia.P5"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p5')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosLuz && esTarifaHastaP6" data-field="DatosLuz.TerminoEnergia.P6"
        editor-type="dxNumberBox" :col-span="2" :editor-options="precioEnergiaNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.p6')" />
      </DxSimpleItem>
    </DxGroupItem>
    <!-- Fin seccion de datos exclusivos de luz -->

    <!-- Seccion de datos exclusivos de gas -->
    <DxGroupItem :col-span="6" :col-count="6" :css-class="claseDatosGas">
      <DxSimpleItem :visible="hayDatosGas" data-field="DatosGas.TerminoFijo" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioGasFijoNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.termino_fijo')" />
      </DxSimpleItem>
      <DxSimpleItem :visible="hayDatosGas" data-field="DatosGas.TerminoVariable" editor-type="dxNumberBox" :col-span="2"
        :editor-options="precioGasVariableNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.termino_variable')" />
      </DxSimpleItem>
      <DxEmptyItem :visible="hayDatosGas" :col-span="2">
      </DxEmptyItem>
    </DxGroupItem>
    <!-- Fin seccion de datos exclusivos de gas -->

    <!-- Costes de gestión adicionales -->
    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem :col-span="6">
        <span class="dx-field-item-label-text text-success">{{
          $t('oferta_energia.form.coste_gestion_adicional')
        }}</span>
      </DxSimpleItem>
      <DxSimpleItem data-field="TipoCosteGestion" editor-type="dxSelectBox" :col-span="2"
        :editor-options="{ ...getSelectBoxDefaultProperties(), ...getSelectBoxFromApiEnum(TipoCosteGestionEnum),
          searchEnabled: true, dropDownOptions: { maxHeight: 190 }, disabled: tieneTramitesAsociados }">
        <DxLabel :text="$t('oferta_energia.form.tipo_coste_gestion')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="CosteGestion" editor-type="dxNumberBox" :col-span="2"
        :editor-options="costeGestionNumberOptions">
        <DxLabel :text="$t('oferta_energia.form.valor_coste_gestion')" />
      </DxSimpleItem>
    </DxGroupItem>
    <!-- Fin costes de gestión adicionales -->

    <!-- Observaciones -->
    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem data-field="Observaciones" :col-span="6">
        <DxLabel :text="$t('oferta_energia.form.observaciones')" />
        <DxTextArea v-model="props.model!.Observaciones" :height="100" />
      </DxSimpleItem>
    </DxGroupItem>

    <template #denoInternaLabel="{ data }">
      <div id="template-content">
        <span class="dx-field-item-label-text">{{ $t('oferta_energia.form.deno_interna') }}</span>
        <div class="info-icon d-inline text-primary">
          <i class="fas fa-info-circle" id="denoInterna"></i>
          <DxTooltip :hide-on-outside-click="false" target="#denoInterna" show-event="mouseenter"
            hide-event="mouseleave">
            <template #content >
              <div id="tooltip-content">{{ $t('oferta_energia.form.deno_interna_texto_informativo') }}</div>
            </template>
          </DxTooltip>
        </div>
      </div>
    </template>
    <template #miscelaneaLabel="{ data }">
      <div id="template-content">
        <span class="dx-field-item-label-text">{{ $t('oferta_energia.form_endesa.miscelanea') }}</span>
        <div class="info-icon d-inline text-primary">
          <i class="fas fa-info-circle" id="miscelanea"></i>
          <DxTooltip :hide-on-outside-click="false" target="#miscelanea" show-event="mouseenter"
            hide-event="mouseleave">
            <template #content>
              <div id="tooltip-content">{{ $t('oferta_energia.form_endesa.miscelanea_texto_informativo') }}</div>
            </template>
          </DxTooltip>
        </div>
      </div>
    </template>
    <template #codigoTalonarioLabel="{ data }">
      <div id="template-content">
        <span class="dx-field-item-label-text">{{ $t('oferta_energia.form_endesa.codigo_talonario') }}</span>
        <div class="info-icon d-inline text-primary">
          <i class="fas fa-info-circle" id="codigoTalonario"></i>
          <DxTooltip :hide-on-outside-click="false" target="#codigoTalonario" show-event="mouseenter"
            hide-event="mouseleave">
            <template #content>
              <div id="tooltip-content">{{ $t('oferta_energia.form_endesa.codigo_talonario_texto_informativo') }}</div>
            </template>
          </DxTooltip>
        </div>
      </div>
    </template>
  </DxForm>
</template>

<script setup lang="ts">
import { DxNumberBox } from 'devextreme-vue';
import {
  DxForm,
  DxItem,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxEmptyItem,
  DxCompareRule,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import DxValidator, { DxCustomRule } from 'devextreme-vue/validator';
import { DxCheckBox, DxTextArea, DxDateBox } from "devextreme-vue";
import { TipoCosteGestionEnum, TipoSuministroTramiteEnergiaEnum, type CreateOfertaEndesaModel, type DetailOfertaEndesaModel, } from '@/.shared/.api';
import { getLookup, getSelectBoxDefaultProperties } from '@/.shared/helpers/grid-helper';
import { getSelectBoxFromApiEnum } from '@/.shared/helpers/enums-helper';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { DatosOfertaLuz } from '@/components/ofertas-energia/base/models/DatosOfertaLuz';
import { DatosOfertaGas } from '@/components/ofertas-energia/base/models/DatosOfertaGas';
import { useIntl } from '@/.shared/services/i18n';
import { DxTooltip } from 'devextreme-vue/tooltip';
import validationEngine from 'devextreme/ui/validation_engine';
import { Constants } from "@/.shared/constants/OperacionEnergia";

const intl = useIntl();

const props = defineProps({
  model: {
    type: Object as () => DetailOfertaEndesaModel | CreateOfertaEndesaModel,
    required: true
  },
  tieneTramitesAsociados: {
    type: Boolean,
    required: true
  }
})

const handleTipoEnergiaChange = (e: any) => {
  switch (e.value) {
    case TipoSuministroTramiteEnergiaEnum.Luz:
      props.model.DatosGas = null
      props.model.DatosLuz = new DatosOfertaLuz();
      break;

    case TipoSuministroTramiteEnergiaEnum.Gas:
      props.model.DatosLuz = null
      props.model.DatosGas = new DatosOfertaGas();
      break;
  }
}

const handleTarifaAccesoChange = (e: any) => {
  if (props.model.TipoEnergia == TipoSuministroTramiteEnergiaEnum.Luz && props.model.DatosLuz)
    switch (e.value) {
      case "2.0TD":
        props.model.DatosLuz.TerminoPotencia.P3 = null;
        props.model.DatosLuz.TerminoPotencia.P4 = null;
        props.model.DatosLuz.TerminoPotencia.P5 = null;
        props.model.DatosLuz.TerminoPotencia.P6 = null;
        props.model.DatosLuz.TerminoEnergia.P4 = null;
        props.model.DatosLuz.TerminoEnergia.P5 = null;
        props.model.DatosLuz.TerminoEnergia.P6 = null;
        break;

      case "3.0TD":
      case "6.1TD":
        props.model.DatosLuz.TerminoPotencia.P3 = 0;
        props.model.DatosLuz.TerminoPotencia.P4 = 0;
        props.model.DatosLuz.TerminoPotencia.P5 = 0;
        props.model.DatosLuz.TerminoPotencia.P6 = 0;
        props.model.DatosLuz.TerminoEnergia.P4 = 0;
        props.model.DatosLuz.TerminoEnergia.P5 = 0;
        props.model.DatosLuz.TerminoEnergia.P6 = 0;
        break;
    }
}

const selectTipoEnergia = { ...getLookup('ofertas', 'tipo_energia'), disabled: props.tieneTramitesAsociados, onValueChanged: handleTipoEnergiaChange };
const optionsTarifaAcceso = ref<Array<{ value: string; text: string }>>([]);
const selectTarifaAcceso = computed(() => {
  return {
    dataSource: optionsTarifaAcceso.value,
    valueExpr: 'text',
    displayExpr: 'text',
    disabled: props.tieneTramitesAsociados,
    onValueChanged: handleTarifaAccesoChange
  }
});

const loadTarifasAcceso = (tipoEnergia: TipoSuministroTramiteEnergiaEnum | undefined) => {
  let newDataSource;

  switch (tipoEnergia) {
    case TipoSuministroTramiteEnergiaEnum.Luz:
      newDataSource = getLookup('ofertas', 'tarifa_acceso_luz').dataSource;
      break;
    case TipoSuministroTramiteEnergiaEnum.Gas:
      newDataSource = getLookup('ofertas', 'tarifa_acceso_gas').dataSource;
      break;
    default:
      newDataSource = [];
  }

  optionsTarifaAcceso.value = [...newDataSource as any[]];
}

onMounted(() => {
  loadTarifasAcceso(props.model?.TipoEnergia);
})

watch(
  () => props.model?.TipoEnergia,
  (newValue) => {
    loadTarifasAcceso(newValue);
    props.model.TarifaAcceso = '';
  }
);

watch(
  () => ({
    aplicaPersonaFisica: props.model.AplicaPersonaFisica,
    aplicaPersonaJuridica: props.model.AplicaPersonaJuridica
  }),
  () => {
    validationEngine.validateGroup("validacionTipoPersona");
  }
)

watch(
  () => ({
    fechaInicio: props.model.FechaInicio,
    fechaFin: props.model.FechaFin
  }),
  () => {
    validationEngine.validateGroup("validacionFechaFin");
  }
)

watch(
  () => ({
    potenciaMin: props.model.DatosLuz?.PotenciaMin,
    potenciaMax: props.model.DatosLuz?.PotenciaMax
  }),
  async () => {
    await nextTick();
    if (hayDatosLuz.value)
      validationEngine.validateGroup("validacionPotenciaMax");
  }
)

const autoconsumoValue = computed({
  get() {
    return props.model?.DatosLuz?.Autoconsumo ?? false;
  },
  set(value) {
    if (props.model?.DatosLuz) {
      props.model.DatosLuz.Autoconsumo = value;
    }
  }
});


const claseDatosLuz = computed(() => {
  return hayDatosLuz.value ? '' : 'd-none';
});

const claseDatosGas = computed(() => {
  return hayDatosGas.value ? '' : 'd-none';
});

function fechaInicio() {
  return props.model.FechaInicio;
}

function potenciaMin() {
  return props.model.DatosLuz?.PotenciaMin;
}

const esTarifaHastaP6 = computed(() => props.model.TarifaAcceso === '3.0TD' || props.model.TarifaAcceso === '6.1TD')

const potenciaMaxValue = computed({
  get() {
    return props.model?.DatosLuz?.PotenciaMax ?? null;
  },
  set(value) {
    if (props.model?.DatosLuz) {
      props.model.DatosLuz.PotenciaMax = value!;
    }
  }
});

const potenciaNumberOptions = {
  showSpinButtons: true,
  step: 0.1,
  format: {
    type: "fixedPoint",
    precision: 2,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(2)), 'decimal') + ' kW';
    }
  },
  disabled: props.tieneTramitesAsociados
};

const precioPotenciaNumberOptions = {
  showSpinButtons: true,
  step: 0.000001,
  format: {
    type: "fixedPoint",
    precision: 6,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(6)), 'decimal') + ' €/kW/día';
    }
  },
  disabled: props.tieneTramitesAsociados
}

const precioEnergiaNumberOptions = {
  showSpinButtons: true,
  step: 0.000001,
  format: {
    type: "fixedPoint",
    precision: 6,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(6)), 'decimal') + ' €/kWh';
    }
  },
  disabled: props.tieneTramitesAsociados
}

const precioGasFijoNumberOptions = {
  showSpinButtons: true,
  step: 0.000001,
  format: {
    type: "fixedPoint",
    precision: 6,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(6)), 'decimal') + ' €/mes';
    }
  },
  disabled: props.tieneTramitesAsociados
}

const precioGasVariableNumberOptions = {
  showSpinButtons: true,
  step: 0.000001,
  format: {
    type: "fixedPoint",
    precision: 6,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(6)), 'decimal') + ' €/kWh';
    }
  },
  disabled: props.tieneTramitesAsociados
}

const costeGestionNumberOptions = computed(() => {
  const suffixUnidad = props.model.TipoCosteGestion
    ? intl.i18n.t(`shared.enums.tipo_coste_gestion.${props.model.TipoCosteGestion}`)
    : "€";
  return {
    showSpinButtons: true,
    step: 0.000001,
    format: {
      type: "fixedPoint" as const,
      precision: 6,
      formatter: (value: number) => {
        return `${intl.i18n.n(Number(value.toFixed(6)), "decimal")} ${suffixUnidad}`;
      }
    },
    min: 0,
    disabled: props.tieneTramitesAsociados || props.model.TipoCosteGestion == null
  };
});

watch(
  () => props.model.TipoCosteGestion,
  (newValue) => {
    if (newValue == null) {
      props.model.CosteGestion = null;
    }
  },
  { immediate: true }
);

const validarTipoPersona = (params: any) => {
  return props.model.AplicaPersonaFisica || props.model.AplicaPersonaJuridica || params.value;
};

const hayDatosLuz = computed(() => {
  return props.model && props.model.DatosLuz != null;
})

const hayDatosGas = computed(() => {
  return props.model && props.model.DatosGas != null;
})

const tieneDenominacionInterna = computed(() =>
  props.model.IdEmpresaServicios === Constants.EmpresaServicios.ID_ENDESA_REAL_ESTATE
);

const tieneMiscelanea = computed(() =>
  props.model.IdEmpresaServicios === Constants.EmpresaServicios.ID_ENDESA_REAL_ESTATE
);

const requiereCodigoTalonario = computed(() =>
  props.model.IdEmpresaServicios === Constants.EmpresaServicios.ID_ENDESA_PPNN_Y_CCPP
);

</script>

<style scoped lang="scss">

.info-icon {
  margin-left: auto;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}

.tooltip {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--background-normal-dark);
  color: var(--text-default-inverse);
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

:deep(.activa-checkbox) {
  margin-top: 30px;
}
</style>
